// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1NvwQ","inner":"Footer_inner__2jZrX"};